import type { TextWidget as TextWidgetType } from '../../types/coach';

interface TextWidgetProps {
  widget: TextWidgetType;
  className?: string;
}

export function TextWidget({ widget, className }: TextWidgetProps) {
  return (
    <div className={`text-sm whitespace-pre-wrap ${className ?? 'text-text-primary'}`}>
      {widget.text}
    </div>
  );
}